export function getErrorMessage(error, fallback = 'Something went wrong.') {
  const values = [error?.messages, error?._server_messages, error?.message, error]
  for (const value of values) {
    const message = extractMessage(value)
    if (message && message !== 'ValidationError') return message
  }
  return fallback
}

function extractMessage(value) {
  if (!value) return ''
  if (Array.isArray(value)) {
    for (const item of value) {
      const message = extractMessage(item)
      if (message) return message
    }
    return ''
  }
  if (typeof value === 'object') return extractMessage(value.message || value.msg || value.exc_message)
  if (typeof value !== 'string') return ''

  const text = value.trim()
  if (!text) return ''
  if (text.startsWith('[') || text.startsWith('{')) {
    try {
      return extractMessage(JSON.parse(text))
    } catch {
      return text
    }
  }
  return text
}
